import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hello Friends! I'm <span className="purple">Rohan Shukla</span> from{" "}
            <span className="purple">Mumbai, India</span>.
            <br />
            I am currently pursuing my third year of B.Tech in the Internet of Things branch at{" "}
            <span className="purple">Thakur College of Engineering & Technology</span>.
            <br />
            I have also completed a Diploma in Computer Engineering with an aggregate of{" "}
            <span className="purple">81.49%</span>.
            <br />
            <br />
            I am passionate about building intelligent, meaningful software that solves real-world problems.
            My journey so far has been driven by curiosity, consistency, and creativity.
          </p>

          <hr />

          <p style={{ textAlign: "justify" }}>
            <strong>🔍 Current Focus:</strong>
            <br />
            Exploring Full Stack Development using the MERN Stack and integrating AI into real-world applications.
          </p>

          <p style={{ textAlign: "justify" }}>
            <strong>📚 Learning & Growing In:</strong>
          </p>
          <ul>
            <li className="about-activity"><ImPointRight /> JavaScript, React, and Node.js</li>
            <li className="about-activity"><ImPointRight /> MongoDB and Express.js</li>
            <li className="about-activity"><ImPointRight /> Python, Machine Learning, and AI Tools</li>
            <li className="about-activity"><ImPointRight /> Git, GitHub, and DevOps Basics</li>
          </ul>

          <p style={{ textAlign: "justify" }}>
            <strong>🎯 Interests Beyond Coding:</strong>
          </p>
          <ul>
            <li className="about-activity"><ImPointRight /> Playing Games (especially strategy & FPS)</li>
            <li className="about-activity"><ImPointRight /> Listening to music that energizes me</li>
            <li className="about-activity"><ImPointRight /> Traveling & exploring new cultures</li>
            <li className="about-activity"><ImPointRight /> Learning about new technologies & trends</li>
          </ul>

          <p style={{ color: "rgb(155 126 172)", fontStyle: "italic" }}>
            "Strive to build things that make a difference!"
          </p>
          <footer className="blockquote-footer">Rohan Shukla</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
